import { PostBodyContent } from '@/components/page/case-study/Body/BodyContent';
import {
  initializeLists,
  processPostBodyList,
  splitLists,
} from '@/components/page/case-study/caseStudyUtils';

import type { SanityBlock, SanityKeyed } from 'sanity-codegen';

type MarkType = 'strong' | 'em' | 'underline' | 'code' | 'strike-through';
type ListItemType = 'bullet' | 'number';

interface BlockChild {
  text: string;
  marks: MarkType[];
}
interface BlockProps extends SanityKeyed<SanityBlock> {
  children: BlockChild[];
  listItem?: ListItemType;
  style: string;
}

export const Block = (block: BlockProps) => {
  return renderBlock(block);
};

const processLists = (block: BlockProps) => {
  const { UlList, ulFirstId, OlList, olFirstId, splitUlList, splitOlList } =
    initializeLists();

  processPostBodyList(block, UlList, ulFirstId, OlList, olFirstId);
  splitLists(ulFirstId, UlList, splitUlList);
  splitLists(olFirstId, OlList, splitOlList);

  return { UlList, ulFirstId, OlList, olFirstId, splitUlList, splitOlList };
};

export const renderBlock = (block: BlockProps) => {
  const { children, listItem, _key, style } = block;
  const { UlList, ulFirstId, OlList, olFirstId, splitUlList, splitOlList } =
    processLists(block);

  const finalUlList = ulFirstId[0] === -1 ? UlList : splitUlList;
  const finalOlList = olFirstId[0] === -1 ? OlList : splitOlList;

  return (
    <PostBodyContent
      block={block}
      id={_key}
      key={_key}
      style={style}
      marks={children[0].marks}
      list={listItem}
      UlList={finalUlList}
      OlList={finalOlList}
    />
  );
};
